module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/SweetPotatoCasserole-6db5aa8638a6761250c55027a6b5a5d6.webp";